import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from "components/dialog";
import {updateNewShieldEventFile} from "../../../../../services/commonService";
import NewAssetApiForm from "../../../../asset/forms/new-form/api-form";

const useStyles = makeStyles(() => ({
    shieldContainer: {
        overflowY: 'visible'
    }
}));

export default function DialogNewShieldApi({
                                                   intl, customerIdSelected, openDialogNewShield, handleCloseDialogNewShield,
                                                   asset, handleChange, assetPath, assetFormDisabled, team,
                                               assetCategories, defaultCategory,
    register
                                               }) {
    const [submitNewShield, setSubmitNewShield] = useState(false);
    const classes = useStyles();

    const handleUpdateNewShield = data => {
        if (data && data._id) {
            handleCloseDialogNewShield();
            handleChange(`sportEventData.teamLogoAsset${team}`, "");
            handleChange(`sportEventData.teamLogo${team}`, data._id);
        }
    }

    const handleUpload = () => {
        updateNewShieldEventFile({ body: { file: asset }, customerId: customerIdSelected }, handleUpdateNewShield);
    }

    useEffect(() => {
        return () => {
            setSubmitNewShield(false);
        }
    }, [])

    return (
        <Dialog contentClassName={classes.shieldContainer} onClose={handleCloseDialogNewShield}
                aria-labelledby="customized-dialog-title"
                open={openDialogNewShield} showModalAccept showModalClose onAccept={handleUpload}
                title={intl.formatMessage({id: "event.asset.newshield"})}>
            <NewAssetApiForm
                customerIdSelected={customerIdSelected}
                submitNewShield={submitNewShield}
                disabled={assetFormDisabled}
                disabledCategorySelection
                onChange={handleChange}
                values={asset}
                path={`${assetPath}.`}
                acceptImage={["image/png"]}
                allowedAssetTypes={["image"]}
                assetCategories={assetCategories}
                defaultCategory={defaultCategory}
                register={register}
            />
        </Dialog>
    );
}
